import { UserOverview } from './user';

export enum WorksheetChecklistItemStatusEnum {
    UNCHECKED = 'UNCHECKED',
    CHECKED = 'CHECKED',
    NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export type WorksheetChecklistItem = {
    id: string;
    checklistItemId: string;
    categoryId?: string | null;
    status: WorksheetChecklistItemStatusEnum;
    createdAt: Date;
    updatedAt: Date;
    name: string;
    description?: string;
    reportCode: string;
    sequence: string;
    reference: string;
    userAction?: UserOverview & { date: Date };
    notApplicableReason?: string;
};

export type WorksheetChecklistItemOverview = {
    id: string;
    status: WorksheetChecklistItemStatusEnum;
};

export type WorksheetChecklistCategory = {
    id: string;
    categoryId?: string | null;
    name: string;
    reference: string;
    createdAt: Date;
    updatedAt: Date;
};

export type WorksheetChecklist = {
    items: WorksheetChecklistItem[];
    categories: WorksheetChecklistCategory[];
};
